import { connect, mapProps } from '@formily/react';
import { CnReadOnly as UiReadOnly } from "../../components/cn-read-only";
import { mapSize, mapStatus } from "../__builtins__";
export var CnReadOnly = connect(UiReadOnly, mapProps(mapSize, mapStatus));
CnReadOnly.displayName = 'CnReadOnly';
